import { CacheStore, CacheStoreOptions } from './cacheStore';

export class CachePool {
    _pool: { [key: string]: CacheStore } = {};

    newStore(name: string, options: CacheStoreOptions = {}) {
        if (!this._pool[name]) {
            options['_internal_'] = true;
            this._pool[name] = new CacheStore({ name, ...options });
        }

        return this.store(name);
    }

    store(name: string) {
        return this._pool[name];
    }
}
